export default function NotFound() {
    return (
        <>
            404 - Page Not Found
        </>
    )
}
